import { IOrganisationIndex } from "../../organisations/model/OrganisationIndex";
import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TDocumentTypeIndexCategory {
  id?: number;
  organisationIndexCategoryId: number;
  documentTypeId: number;
  maxLength: number;
  valid: boolean;
  required: boolean;
  organisationIndexList?: IOrganisationIndex[];
}

export interface IDocumentTypeIndexCategory
  extends TDocumentTypeIndexCategory {}

const DocumentTypeIndexCategory = Model(
  (model: TDocumentTypeIndexCategory): IDocumentTypeIndexCategory => {
    const _value: TDocumentTypeIndexCategory = Object.assign({}, model);

    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get organisationIndexCategoryId() {
        return _value.organisationIndexCategoryId;
      },
      set organisationIndexCategoryId(value) {
        _value.organisationIndexCategoryId = value;
      },
      get documentTypeId() {
        return _value.documentTypeId;
      },
      set documentTypeId(value) {
        _value.documentTypeId = value;
      },
      get maxLength() {
        return _value.maxLength;
      },
      set maxLength(value) {
        _value.maxLength = value;
      },
      get required() {
        return _value.required;
      },
      set required(value) {
        _value.required = value;
      },
      get valid() {
        return _value.valid;
      },
      set organisationIndexList(value) {
        _value.organisationIndexList = value;
      },
      get organisationIndexList() {
        return _value.organisationIndexList;
      },
      set valid(value) {
        _value.valid = value;
      }
    };

    return ValidatableObject<IDocumentTypeIndexCategory>(_model);
  }
);

export default DocumentTypeIndexCategory;
